import { DictionaryFilterDefinition, DictionaryTypeEnum, FilterTypeEnum } from '../filters-model';

export interface ChannelsSetFormFilters {
    locations?: DictionaryFilterDefinition;
    departments?: DictionaryFilterDefinition;
    functions?: DictionaryFilterDefinition;
  }
  export const INITIAL_CHANNELS_SET_FORM_FILTERS: ChannelsSetFormFilters = {
    locations: {
      type: FilterTypeEnum.DICTIONARY,
      dictionary: DictionaryTypeEnum.LOCATIONS,
      label: 'Location',
      changable: true,
      value: []
    },
    departments: {
      type: FilterTypeEnum.DICTIONARY,
      dictionary: DictionaryTypeEnum.DEPARTMENTS,
      label: 'Department',
      changable: true,
      value: []
    },
    functions: {
      type: FilterTypeEnum.DICTIONARY,
      dictionary: DictionaryTypeEnum.FUNCTIONS,
      label: 'Function',
      changable: true,
      value: []
    }
  }
